import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/mapTo'
import * as App from '../../app'
import * as DateUtils from '../../components/date-selector'
import * as Menu from '../../components/menu'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'

const initialLoad = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  { history }: App.Dependencies,
) => action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.includes(Menu.CONTENT_IMPORTS_URL))
  .map(() =>
    Actions.fetchImports(
      store.getState().app.selectedCommunity,
      DateUtils.dateFromUrlParams(history.location)))

export const epic = ReduxObservable.combineEpics(
  initialLoad,
)



// WEBPACK FOOTER //
// ./src/pages/imports/epic.ts